module.exports = __webpack_public_path__ + "static/mobile-3-bee55e6151dc2ebb69324bc7212f8305.png";